import { PackingTaskVerifyPickingPage } from "@/features/packing-task/pages/PackingTaskVerifyPickingPage";
import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/admin/packing-task/$id/verify")({
  beforeLoad({ context }) {
    if (!context.authAdapter.can({ permissions: ["packing_task.verify"] })) {
      throw redirect({ to: "/403" });
    }
  },
  component: PackingTaskVerifyPickingPage,
});
